import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 20a8 8 0 0 0 8-8 8 8 0 0 0-8-8 8 8 0 0 0-8 8 8 8 0 0 0 8 8Zm5.6 2h-1.044c-1.387.637-2.931 1-4.556 1s-3.163-.363-4.556-1H14.4A8.402 8.402 0 0 0 6 30.4V33a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3v-2.6c0-4.637-3.762-8.4-8.4-8.4Z" })
});
export default SvgUser;
